import { AbstractFilterHandler } from '../AbstractFilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';
import type { Lesson } from '@/models/lesson';
import type { XLesson } from '@/models/xlesson';

export class SearchQueryFilterHandler extends AbstractFilterHandler {
    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        const arr = JSON.parse(JSON.stringify(data)) as FilterData[];
        let res: FilterData[];

        const regExQuery = new RegExp(filterOptions.searchQuery.trim(), 'i');

        const insightFilterLesson = (lessons: Lesson[]): Lesson[] => {
            return lessons.filter((lesson: Lesson) => {
                if (lesson.sub_lessons) {
                    lesson.sub_lessons = insightFilterLesson(lesson.sub_lessons);
                }

                if (lesson.more_info) {
                    return (
                        lesson.insight.search(regExQuery) !== -1 ||
                        lesson.more_info.search(regExQuery) !== -1 ||
                        lesson.sub_lessons.length > 0
                    );
                } else {
                    return lesson.insight.search(regExQuery) !== -1 || lesson.sub_lessons.length > 0;
                }
            });
        };

        const insightFilterXLesson = (xLessons: XLesson[]): XLesson[] => {
            return xLessons.filter((lesson: XLesson) => {
                if (lesson.sub_lessons) {
                    lesson.sub_lessons = insightFilterXLesson(lesson.sub_lessons);
                }

                if (lesson.more_info) {
                    return (
                        lesson.insight.search(regExQuery) !== -1 ||
                        lesson.more_info.search(regExQuery) !== -1 ||
                        lesson.sub_lessons.length > 0
                    );
                } else {
                    return lesson.insight.search(regExQuery) !== -1 || lesson.sub_lessons.length > 0;
                }
            });
        };

        if (filterOptions.searchQuery !== undefined && filterOptions.searchQuery.trim().length !== 0) {
            res = arr.filter((el: FilterData) => {
                if (el.x_lessons) {
                    el.x_lessons = insightFilterXLesson(el.x_lessons);
                } else if (el.lessons) {
                    el.lessons = insightFilterLesson(el.lessons);
                }

                const elTitleMatch = el.title.search(regExQuery) !== -1;
                return elTitleMatch || el.lessons.length > 0;
            });
        } else {
            res = arr;
        }

        return super.handle(res, filterOptions);
    }
}
